import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../config/globalVariables";

import { setupCache } from "axios-cache-interceptor";
import { axiosRequestMiddleware } from "../middleware/axiosRedirect";

const kvkkClient = axios.create({
  baseURL: `${API_GATEWAY}${PR_DEP}/kvkk`,
});
kvkkClient.interceptors.request.use(axiosRequestMiddleware);
const cacheKvkkClient = setupCache(kvkkClient);
cacheKvkkClient.interceptors.response.use(
  (response) => {
    if (
      response.status >= 200 &&
      response.status < 300 &&
      response.config.method !== "get"
    ) {
      cacheKvkkClient.storage.data = {};
    }
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);
export { kvkkClient, cacheKvkkClient };
